import DateUtils from '../../../../core/utils/date'
import { VpIconButton } from '@vtmn-play/react'
import { VpArrowRightIcon } from '@vtmn-play/icons/react'
import DailyBoard from './daily/daily-board'
import { useContext, useState } from 'react'
import { HomeContext } from '../../state/home-context'
import { useNavigate } from 'react-router'
import { getPathFromRouteId } from '../../../../core/utils/route-utils'
import { RouteId } from '../../../../core/routing/router/route-ids'
import WeeklyGmvProgressCard from '../weekly-gmv-progress/weekly-gmv-progress-card'
import WeeklyGoal from './goal/weekly-goal'
import WeeklyGmvForecastGap from './gap/weekly-gmv-forecast-gap'
import { HOMEPAGE_CARD_REDIRECTS, HOMEPAGE_EVENTS } from 'core/constants/homepage-analytics'
import { useHomepageAnalytics } from '../../analytics/use-homepage-analytics'
import { TEMPLATE_NAME } from '../../../../core/utils/templates'
import WeeklyTitle from './weekly-title'

const getDebriefDepartmentManagerTemplate = (templates: { id: number; label: string }[]) => {
  return templates?.find(template => template.label.startsWith(TEMPLATE_NAME.DEBRIEF_DEPARTMENT_MANAGER)) ?? ''
}
const Weekly = () => {
  const currentDate = new Date()
  const currentWeekNumber = DateUtils.getWeekNumber(currentDate)
  const [weekDate, setWeekDate] = useState(currentDate)
  const yearWeek = DateUtils.dateToYearWeekFormat(weekDate)
  const isCurrentWeek = DateUtils.getWeekNumber(weekDate) === currentWeekNumber
  const { aggregation, teamId, storeId, templates } = useContext(HomeContext)

  const trackHomepageEvent = useHomepageAnalytics()
  const navigate = useNavigate()

  const navigateToWeekly = (aggregation: string, teamId: number, storeId: number, weekDate: Date) => {
    if (aggregation === 'TEAM') {
      trackHomepageEvent(HOMEPAGE_EVENTS.CARD_REDIRECT_CLICK, { card: HOMEPAGE_CARD_REDIRECTS.WEEKLY })
      const teamSearch = teamId ? `&team=${teamId}` : ''
      const debriefDepartmentManagerTemplate = getDebriefDepartmentManagerTemplate(templates)
      const templateSearch = debriefDepartmentManagerTemplate ? `&template=${debriefDepartmentManagerTemplate.id}` : ''
      void navigate({
        pathname: getPathFromRouteId(RouteId.WeeklyTeams),
        search: `?year=${DateUtils.getYearNumberFromLabel(yearWeek)}&store_id=${storeId}&week=${DateUtils.getWeekNumber(weekDate)}${teamSearch}${templateSearch}`
      })
    }
  }

  return (
    <div className="mg-weekly">
      <div className="mg-weekly-header">
        <WeeklyTitle currentWeekNumber={currentWeekNumber} weekDate={weekDate} onWeekDateChange={setWeekDate} />
        {aggregation === 'TEAM' && (
          <div className="mg-weekly-cta">
            <VpIconButton
              variant="secondary"
              variantStyle="regular"
              size="small"
              onClick={() => {
                navigateToWeekly(aggregation, teamId, storeId, weekDate)
              }}
              data-testid="weekly-navigate-button"
            >
              <VpArrowRightIcon />
            </VpIconButton>
          </div>
        )}
      </div>
      <div className="mg-weekly-body">
        <div className="mg-weekly-gmv-realized">
          <WeeklyGmvProgressCard yearWeek={yearWeek} />
        </div>
        <DailyBoard yearWeek={yearWeek} isCurrentWeek={isCurrentWeek} />
        <div className="mg-weekly-right">
          <WeeklyGoal isCurrentWeek={isCurrentWeek} />
          <WeeklyGmvForecastGap yearWeek={yearWeek} />
        </div>
      </div>
    </div>
  )
}

export default Weekly
